import React, { FC } from 'react'
import { Card, Grid } from 'antd'
import { OrganizationWithPermissions } from 'services'
import { CardHeader } from './CardHeader'
import { CardBody } from './CardBody'
import { useHistory } from 'react-router-dom'

interface OrgCardProps {
  info: OrganizationWithPermissions
}

export const OrgCard: FC<OrgCardProps> = ({ info }) => {
  const { xs } = Grid.useBreakpoint()
  const history = useHistory()

  return (
    <Card
      size={xs ? 'small' : 'default'}
      hoverable
      onClick={(e) => {
        history.push(`/${info.account_name}?tab=members`)
      }}
      style={{
        width: '100%'
      }}
      headStyle={{
        margin: 0,
        padding: xs ? '0 6px' : '0 12px',
      }}
      title={<CardHeader info={info} />}
    >
      <CardBody info={info} />
    </Card>
  )
}
